

const INK = "#0F1B2D";
const CYAN = "#4F86D6";
const CYAN_DARK = "#0E509C";
const ORANGE = "#E0663F";
const fmt = (n) => `$${Math.round(n).toLocaleString()}`;
import { ADDONS, HOURLY } from "./pricing";

export function AddonConfigurator({ addons, setAddon }) {
  return (
          <div className="rt-card p-6">
            <div className="rt-eyebrow mb-1">Add-on modules · with named people on our team</div>
            <p className="text-[13px] mb-4" style={{ color: INK, opacity: 0.65 }}>
              Each add-on is a flat <strong>${ADDONS[0].monthly}/mo</strong> for the module, plus a named specialist from our team whose
              time is billed at <strong>${HOURLY}/hr</strong> — only the hours used, estimated up front. Slide to set the hours you expect.
            </p>
            <div className="space-y-3">
              {ADDONS.map((a) => {
                const st = addons[a.key];
                return (
                  <div key={a.key} className="rounded-2xl border p-4 transition-colors" style={{ borderColor: st.on ? CYAN : "#E5EDF5", background: st.on ? `${CYAN}0d` : "#fff" }}>
                    <div className="flex flex-wrap items-center justify-between gap-3">
                      <label className="flex items-start gap-3 cursor-pointer flex-1 min-w-[220px]">
                        <input type="checkbox" checked={st.on} onChange={(e) => setAddon(a.key, { on: e.target.checked })} data-testid={`addon-toggle-${a.key}`} className="h-4 w-4 mt-1 accent-[#0E509C]" />
                        <div>
                          <div className="rt-h text-[15px]" style={{ color: INK }}>{a.label}</div>
                          <div className="text-[11.5px] font-bold" style={{ color: CYAN_DARK }}>{a.specialist} included</div>
                          <div className="text-[12px] leading-snug mt-0.5" style={{ color: INK, opacity: 0.6 }}>{a.sub}</div>
                        </div>
                      </label>
                      <div className="rt-h text-lg" style={{ color: st.on ? CYAN_DARK : INK, opacity: st.on ? 1 : 0.4 }} data-testid={`addon-monthly-${a.key}`}>
                        +{fmt(a.monthly)}<span className="text-sm opacity-55">/mo</span>
                      </div>
                    </div>
                    {st.on && (
                      <div className="mt-3 rounded-xl px-3.5 py-2.5" style={{ background: "#F4F8FC", border: "1px solid #E5EDF5" }}>
                        <div className="flex flex-wrap items-center justify-between gap-2 text-[12.5px]">
                          <span className="font-bold" style={{ color: INK }}>Specialist hours you expect · {st.hours} hrs/mo @ ${HOURLY}/hr</span>
                          <span className="rt-h text-[14px]" style={{ color: ORANGE }} data-testid={`addon-est-${a.key}`}>≈ {fmt(st.hours * HOURLY)}/mo · billed as used</span>
                        </div>
                        <input type="range" min={0} max={20} value={st.hours} onChange={(e) => setAddon(a.key, { hours: Number(e.target.value) })} data-testid={`addon-hours-${a.key}`} className="w-full accent-[#E0663F] mt-1" />
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          </div>

  );
}
